import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createCar, fetchCars, fetchModelBrand } from "../redux/actions";
import Alert from "./alert";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { carModel } from "../models";
import { useMemo } from "react";

function showDropDown() {
  const dropDownMenu = document.querySelector(".drop-down");
  dropDownMenu.classList.toggle("visible");
}

function showDropDownTwo() {
  const dropDownMenuTwo = document.querySelector(".drop-down-two");
  dropDownMenuTwo.classList.toggle("visible");
}

const CarsTopTools = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const alertBox = useSelector((state) => state.app.alertBox);
  const modelBrand = useSelector((state) => {
    return state.cars.modelbrand;
  });

  const theme = useSelector((state) => state.app.theme);

  const { register, handleSubmit, watch } = useForm({
    defaultValues: carModel,
  });

  const [carImg, setCarImg] = useState(null)

  const watchBrand = watch('brand')

  const [currentFilter, setCurrentFilter] = useState({
    brand: "",
    model: "Select a model",
    price: "",
    color: "",
  });

  const [selectedBrand, setSelectedBrand] = useState("Select a brand");

  useEffect(() => {
    dispatch(fetchModelBrand());
  }, []);

  const allBrands = useMemo(
    () => modelBrand.map((item) => Object.keys(item)),
    [modelBrand]
  );

  function filterHandler(event) {
    setCurrentFilter({
      ...currentFilter,
      [event.target.name]: event.target.value,
    });
  }

  const returnModels = useMemo(() => {
    if (watchBrand) {
      return modelBrand.map((model, index) => {
        if (Object.keys(model) == watchBrand) {
          const newArr = model[watchBrand];
          const listofmodels = [];
          newArr.map((car, index) => {
            listofmodels.push(
              <option value={car} key={index}>
                {car}
              </option>
            );
          });
          return listofmodels;
        }
      });
    } else {
      return <option>Select brand first</option>;
    }
  }, [watchBrand]);

  function resetFilter(e) {
    e.preventDefault();
    setCurrentFilter({
      brand: "",
      model: "Select a model",
      price: "",
      color: "",
    });
    dispatch(fetchCars());
  }

  function filteredSearch() {
    dispatch(fetchCars(currentFilter));
  }

  function showWindow() {
    const window = document.querySelector(".panel");
    const plus = document.querySelector(".plus");
    const blurLayer = document.querySelector(".blur-layer");
    const body = document.querySelector("body");
    body.classList.toggle("hideScroll");
    blurLayer.classList.toggle("visible");
    plus.classList.toggle("rotate");
    window.classList.toggle("visible");
  }

  const handleCarImg = (event) => {
    if (event.target.files[0]) {
      setCarImg(event.target.files[0])
    } else {
      setCarImg(null)
    }
  }

  function sendCarInfo(data) {
    // e.preventDefault()
    const car = new FormData()

    for (const [key, value] of Object.entries(data)) {
      car.append(key, value)
    }
    car.append('photo', carImg)

    console.log(car);
    dispatch(createCar(car));
    reset();
  }

  return (
    <div className="top-tools">
      {alertBox && <Alert text={alertBox.text} type={alertBox.type} />}
      <div className={`tools-inner ${theme}`}>
        <div className="tools-item brand">
          <h6 className="tools-title">{t("brand")}</h6>
          <div onClick={showDropDown} className="drop-down-title">
            {(() => {
              if (`${currentFilter.brand}`) {
                return `${currentFilter.brand}`;
              } else {
                return `${selectedBrand}`;
              }
            })()}
          </div>
          <div className={`drop-down ${theme}`}>
            <div
              className="drop-down-element"
              onClick={(e) => {
                setCurrentFilter({ ...currentFilter, brand: "Select a brand" });
                showDropDown();
              }}
            >
              Select a brand
            </div>
            {allBrands.map((brand, index) => {
              return (
                <div
                  key={index}
                  className="drop-down-element"
                  onClick={(e) => {
                    setCurrentFilter({ ...currentFilter, brand: `${brand}` });
                    showDropDown();
                  }}
                >
                  <p>{brand}</p>
                </div>
              );
            })}
          </div>
        </div>
        <div className="tools-item model">
          <h6 className="tools-title">{t("model")}</h6>
          <div onClick={showDropDownTwo} className="drop-down-title">
            {currentFilter.model ? currentFilter.model : 'Select a model'}
          </div>
          <div className={`drop-down-two ${theme}`}>
            <div
              className="drop-down-element"
              onClick={(e) => {
                setCurrentFilter({ ...currentFilter, model: "Select a model" });
                showDropDown();
              }}
            >
              Select a brand
            </div>
            {(() => {
              if (`${currentFilter.brand}` === "Select a brand") {
                return <div className="drop-down-element">Select a brand</div>;
              }
              if (`${currentFilter.brand}`) {
                return (
                  <>
                    {modelBrand.map((model, index) => {
                      if (Object.keys(model) == `${currentFilter.brand}`) {
                        const newArr = model[currentFilter.brand];
                        const listofmodels = [];
                        newArr.map((car, index) => {
                          listofmodels.push(
                            <div
                              className="drop-down-element"
                              key={index}
                              onClick={(e) => {
                                setCurrentFilter({
                                  ...currentFilter,
                                  model: `${car}`,
                                });
                                showDropDownTwo();
                              }}
                            >
                              <p>{car}</p>
                            </div>
                          );
                        });
                        return listofmodels;
                      }
                    })}
                  </>
                );
              } else {
                return <div className="drop-down-element">Select a brand</div>;
              }
            })()}
          </div>
        </div>
        <div className="tools-item price">
          <h6 className="tools-title">{t("price")}</h6>
          <input
            className="tools-price"
            type="number"
            name="price"
            value={currentFilter.price}
            onChange={filterHandler}
          />
        </div>
        <div className="tools-item color">
          <h6 className="tools-title">{t("color")}</h6>
          <div className="tools-color-picker">
            <input
              className="tools-color"
              type="text"
              name="color"
              value={currentFilter.color}
              placeholder="Color"
              onChange={filterHandler}
            />
            <span className="color-box"></span>
          </div>
        </div>
        <div className="tools-item buttons">
          <button className="search-btn" onClick={filteredSearch}>
            {search}
          </button>
          <button className="search-btn" onClick={resetFilter}>
            {reset}
          </button>
          <div className="blur-layer"></div>
          <button className="search-btn plus" onClick={showWindow}>
            {plus}
          </button>
          <div className="panel">
            <form onSubmit={handleSubmit(sendCarInfo)}>
              <input
                type="text"
                list="brands"
                placeholder={`${t("brand")}`}
                {...register("brand")}
              />
              <datalist id="brands">
                {allBrands.map((brand, index) => {
                  return (
                    <option value={brand} key={index}>
                      {brand}
                    </option>
                  );
                })}
              </datalist>
              <input
                type="text"
                list="models"
                placeholder={`${t("model")}`}
                {...register("model")}
              />
              <datalist id="models">
                {returnModels}
              </datalist>
              <input placeholder={`${t("toning")}`} {...register("toning")} />
              <input
                type="number"
                placeholder={`${t("yearOfIssue")}`}
                min="1980"
                max={new Date().getFullYear().toString()}
                name="year_of_issue"
                {...register('year_of_issue')}
              />
              <input placeholder={`${t("color")}`} {...register("color")} />
              <input
                type="number"
                placeholder={`${t("cost")}`}
                {...register("cost")}
              />
              <input
                placeholder={`${t("engineNum")}`}
                {...register("engine_num")}
              />
              <input
                placeholder={`${t("bodyNum")}`}
                {...register("body_num")}
              />
              <input
                placeholder={`${t("techPassport")}`}
                {...register("tech_passport")}
              />
              <input placeholder={`${t("number")}`} {...register("car_num")} />
              <input
                placeholder={`${t("spareWheel")}`}
                {...register("spare_wheel")}
              />
              <input
                placeholder={`${t("accumulator")}`}
                {...register("battery")}
              />
              <input
                placeholder={`${t("wheelsModel")}`}
                {...register("wheels_model")}
              />
              <input
                type="number"
                placeholder={`${t("rentCostDay")}`}
                {...register("rent_cost")}
              />
              <input type="file" onChange={handleCarImg} />
              <button type="submit">{`${t("create")}`}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarsTopTools;

const search = (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fal"
      data-icon="search"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"
      ></path>
    </svg>
  );
  const plus = (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fal"
      data-icon="plus"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
    >
      <path
        fill="currentColor"
        d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
      ></path>
    </svg>
  );
  const reset = (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fal"
      data-icon="redo"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M492 8h-10c-6.627 0-12 5.373-12 12v110.625C426.804 57.047 346.761 7.715 255.207 8.001 118.82 8.428 7.787 120.009 8 256.396 8.214 393.181 119.166 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-7.069-7.069c-4.503-4.503-11.749-4.714-16.482-.454C361.218 449.238 311.065 470 256 470c-117.744 0-214-95.331-214-214 0-117.744 95.331-214 214-214 82.862 0 154.737 47.077 190.289 116H332c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12z"
      ></path>
    </svg>
  );